export const RECAPTCHA_TYPE = "recaptcha_enterprise_v3";
export const RECAPTCHA_PARAM_SITE_KEY = "siteKey";
export const RECAPTCHA_PARAM_ACTION = "action";
// Key used in clientArtifacts to carry the reCAPTCHA token to the backend
export const RECAPTCHA_CLIENT_ARTIFACT_TOKEN = "scfRecaptchaToken";
